// extracted by mini-css-extract-plugin
export default {"wrapper":"EditClientGeneralForm_wrapper__L1J43","submitWrapper":"EditClientGeneralForm_submitWrapper__TzsO7"};